import { render, staticRenderFns } from "./upload_file.vue?vue&type=template&id=50ebfda6&scoped=true&"
import script from "./upload_file.vue?vue&type=script&lang=js&"
export * from "./upload_file.vue?vue&type=script&lang=js&"
import style0 from "./upload_file.vue?vue&type=style&index=0&id=50ebfda6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ebfda6",
  null
  
)

export default component.exports